import mitt from 'mitt';

export default {
  install(app) {
    const emitter = new mitt();

    app.provide('Emitter', emitter);
  },
};
